(function (Translator) {
    // lv
    Translator.add("rate_list.rate.bg_kbcbank", "KBC Bank summa", "EvpThemeBundle", "lv");
    Translator.add("recaptcha.description", "\u0160is zi\u0146ojums ir paredz\u0113ts, lai p\u0101rbaud\u012btu, vai persona pati p\u0101rl\u016bko lapu un lai izvair\u012btos no autom\u0101tisk\u0101s p\u0101rbaudes sist\u0113m\u0101m", "EvpThemeBundle", "lv");
    Translator.add("recaptcha.title", "Vai esat robots?", "EvpThemeBundle", "lv");
})(Translator);
